<template>
  <div id="app" class="app">
    <router-view />
  </div>
</template>
<script>
export default {
  name: 'AdminApp',

  data() {
    return {

    };
  },

  mounted() {

  },
  created() {
  }
};
</script>

<style lang="scss">
.app {
  min-width: 1400px;
}

* {
  margin: 0;
  padding: 0;
}

ul {
  list-style-type: none;
}

.w200 {
  width: 200px;
}

.w250 {
  width: 250px;
}

.w300 {
  width: 300px;
}

.flex {
  display: flex;
  justify-content: center;
  align-items: center;
}

.fw-w {
  flex-wrap: wrap;
}

.jc-fs {
  justify-content: flex-start;
}

.jc-fe {
  justify-content: flex-end;
}

.jc-sb {
  justify-content: space-between;
}

.jc-se {
  justify-content: space-evenly;
}

.jc-sa {
  justify-content: space-around;
}

.ai-fs {
  align-items: flex-start;
}

.ai-fe {
  align-items: flex-end;
}

.fd-c {
  flex-direction: column;
}

.f-r {
  float: right;
}

.f-l {
  float: left;
}

.mr-15 {
  margin-right: 15px;
}

.ml-15 {
  margin-left: 15px;
}

.mt-15 {
  margin-top: 15px;
}

.mb-15 {
  margin-bottom: 15px;
}

.w100p {
  width: 100% !important;
}

.w150 {
  width: 150px !important;
}

.w200 {
  width: 200px !important;
}

.w250 {
  width: 250px !important;
}

.w300 {
  width: 300px !important;
}

.w350 {
  width: 350px !important;
}

.p-r {
  position: relative;
}

.c-p {
  cursor: pointer;
}
</style>

<style lang="scss" scoped>
// 修正表格
::v-deep .el-table th.gutter {
  display: table-cell !important;
}
</style>

<style lang="scss" scoped>
// 父菜单输入框遮挡
::v-deep .searchMenu {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 999;
  cursor: text;
}
</style>
